"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _333ftIcon = createIcon({
  displayName: "_333ftIcon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        clipRule="evenodd"
        d="m297.347 38.75h150.324c-2.358 14.614-4.715 28.522-6.832 42.466-4.767 31.389-10.035 62.72-13.91 94.22-2.841 23.104-4.688 46.413-5.387 69.679-1.217 40.591 3.011 80.761 11.858 120.472 4.169 18.714 7.707 37.605 10.552 56.563 2.025 13.481-3.539 21.915-16.613 25.861-8.038 2.425-16.657 4.075-25.018 4.087-35.923.047-71.861-1.427-107.766-.78-23.023.415-45.976 3.885-69 5.371-17.807 1.151-35.682 1.999-53.514 1.808-21.471-.229-42.938-1.552-64.39-2.695-11.739-.625-21.145-10.619-21.979-22.23-.284-3.946.877-5.913 4.922-6.602 65.386-11.154 123.136-40.638 179.522-73.89 25.534-15.058 36.307-38.033 40.95-65.445 5.695-33.606 5.668-67.438 2.594-101.212-3.636-39.927-8.194-79.771-12.479-119.638-.993-9.235-2.504-18.413-3.834-28.035z"
        fillRule="evenodd"
        fill="currentColor"
      />
      <path d="m44.893 98.229h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m121.868 98.229h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m198.842 98.229h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m45.168 175.203h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m122.143 175.203h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m199.117 175.203h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m45.306 252.178h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m122.28 252.178h54.982v54.982h-54.982z" fill="currentColor" />
      <path d="m199.255 252.178h54.981v54.982h-54.981z" fill="currentColor" />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _333ftIcon;
